module.exports = __webpack_public_path__ + "img/share.015d9b20.svg";